import { combineReducers } from 'redux';

import auth from './Auth/reducer';
import users from './Users/reducer';
import institutions from './Institutions/reducer';
import courses from './Courses/reducer';
import sections from './Sections/reducer';
import notification from './Notifications/reducer';

const rootReducer = combineReducers({
	auth,
	users,
	institutions,
	courses,
	sections,
	notification,
});

export default rootReducer;
